import React from 'react';
import notice from 'src/common/components/Notice';
import BaseModal from 'src/common/components/Modal';
import { parameterAPI } from 'src/api/modules/parameters';

const DeleteParam = ({ open, onClose, onSuccess, parameter }) => {
	const onDeleteData = () => {
		parameterAPI
			.getParameterDisable(parameter.id, 'E')
			.then(() => {
				onSuccess('Eliminado correctamente', 'success', 3);
			})
			.catch(() => {
				notice('Ocurrió un error al eliminar el parámetro');
			});
	};
	return (
		<BaseModal
			open={open}
			mainText="Eliminar Parámetro"
			confirmLabel="Si, eliminar"
			onConfirm={onDeleteData}
			onClose={onClose}
			onCancel={onClose}
		>
			<p>
				<font size="4">
					Esta seguro que desea eliminar <strong>{parameter?.nombre}</strong>
				</font>
			</p>
		</BaseModal>
	);
};

export default DeleteParam;
